// Lo que vuelve de un trabajo largo (el escritor, una generación) sobre el plan VIVO, que la
// persona y el agente pudieron tocar mientras tanto. Puro.
import type { ItemDelPlan, PlanDeCatalogo } from './plan';

const sinPendientes = (i: ItemDelPlan): ItemDelPlan => {
  const { edicion: _e, rehacer: _r, ...resto } = i;
  return resto;
};

/** Los prompts que escribió el escritor (`llegado`) sobre el plan vivo: sólo los ítems no fijados y
 *  que siguen existiendo. Un prompt nuevo deja la foto y suelta lo pendiente sobre el prompt viejo.
 *  La `tarea` y `pielExpuesta` que declaró el escritor viajan con su prompt: eligen el motor. */
export function fundirPrompts(vivo: PlanDeCatalogo, llegado: PlanDeCatalogo): PlanDeCatalogo {
  const porId = new Map(llegado.productos.flatMap((pr) => pr.items.map((i) => [i.id, i] as const)));
  return {
    ...vivo,
    productos: vivo.productos.map((pr) => ({
      ...pr,
      items: pr.items.map((i) => {
        const l = porId.get(i.id);
        if (!l || i.fijado) return i;
        const reescrito = l.prompt !== i.prompt && l.estado === 'escrito';
        const { tarea: _t, pielExpuesta: _p, ...base } = reescrito ? sinPendientes(i) : i;
        return {
          ...base,
          prompt: l.prompt,
          estado: l.estado,
          motivo: l.motivo,
          ...(l.tarea ? { tarea: l.tarea } : {}),
          ...(l.pielExpuesta !== undefined ? { pielExpuesta: l.pielExpuesta } : {}),
        };
      }),
    })),
  };
}

/**
 * Los estados de generación (`llegado`) sobre el plan vivo: executionId, imageIds, estado y los
 * lotes. Un ítem que esta generación lanzó (su `executionId` cambió) suelta su edición o su
 * rehacer pendiente; uno que no, conserva lo que se le marcó mientras tanto
 * (ADR-2026-10-14-el-agente-edita-el-catalogo-en-masa).
 */
export function fundirEstados(vivo: PlanDeCatalogo, llegado: PlanDeCatalogo): PlanDeCatalogo {
  const porId = new Map(llegado.productos.flatMap((pr) => pr.items.map((i) => [i.id, i] as const)));
  return {
    ...vivo,
    lotes: llegado.lotes,
    productos: vivo.productos.map((pr) => ({
      ...pr,
      items: pr.items.map((i) => {
        const l = porId.get(i.id);
        if (!l) return i;
        const lanzado = !!l.executionId && l.executionId !== i.executionId;
        const { previas: _p, fueEdicion: _f, ...base } = lanzado ? sinPendientes(i) : i;
        return {
          ...base,
          estado: l.estado,
          motivo: l.motivo,
          executionId: l.executionId,
          imageIds: l.imageIds,
          ...(l.previas ? { previas: l.previas } : {}),
          ...(l.fueEdicion ? { fueEdicion: true as const } : {}),
          ...(l.lanzadoEn ? { lanzadoEn: l.lanzadoEn } : {}),
        };
      }),
    })),
  };
}
